import React from 'react';
import styles from './InitiativeCardSummary.module.scss';
import { WidgetItem } from './WidgetItem/WidgetItem';
import { InitiativeProgress } from '../../../../../../../../Models/InitiativeValue';
import { formatDate } from '../../../../../../../../Helpers';
import { CustomerContext } from 'ui-smartforce-settings';

export interface InitiativeCardSummaryProps {
  startDate: string;
  endDate: string;
  progress: InitiativeProgress;
  allDay: boolean;
}

export const InitiativeCardSummary = ({
  startDate,
  endDate,
  progress,
  allDay
}: InitiativeCardSummaryProps): React.ReactElement<InitiativeCardSummaryProps> => {
  const timezone = React.useContext(CustomerContext).customer
    ?.timezone as string;

  return (
    <div className={styles.initiativeCardSummary}>
      <WidgetItem
        title="Start Date"
        value={formatDate(
          startDate,
          `MM/DD/YYYY${allDay ? '' : ' - HH:mm'}`,
          timezone
        )}
      />
      <WidgetItem
        title="End Date"
        value={formatDate(
          endDate,
          `MM/DD/YYYY${allDay ? '' : ' - HH:mm'}`,
          timezone
        )}
      />
      <WidgetItem
        title="Progress"
        value={`${progress.current} of ${progress.total} days`}
      />
      <WidgetItem title="Repeat" value="Never" isLastItem={true} />
    </div>
  );
};
